import { FC, Fragment } from 'react';
import { Card, Flex, List } from 'antd';
import { PageName, useApp } from '@/App';
import CountUp from 'react-countup';

import { useQuery } from '@tanstack/react-query';
import { getSCRisalah } from '@/libs/fleet-api/services/nap';

const SCThingsToDo: FC = () => {
	const { navigate } = useApp();

	const risalahData = useQuery({
		queryKey: ['getSCRisalah'] as const,
		queryFn: () => {
			return getSCRisalah({});
		},
	});

	const data = [
		{
			title: 'Risalah Pemutusan Plafon',
			count: risalahData.data?.data?.totalCount ?? 0,
			link: 'SCRisalahListPage',
		},
	];

	return (
		<Fragment>
			<List
				grid={{ gutter: 20, column: 2 }}
				dataSource={data}
				renderItem={(item) => {
					return (
						<List.Item style={{ marginBottom: 20 }}>
							<Card
								hoverable
								size="small"
								style={{ borderRadius: 0 }}
								onClick={() => {
									navigate(item.link as PageName);
								}}
							>
								<Flex
									justify="space-between"
									align="center"
								>
									{item.title}
									<div
										className={`badge-todo ${item.count > 0 ? 'badge-active' : ''}`}
									>
										<CountUp end={item.count} />
									</div>
								</Flex>
							</Card>
						</List.Item>
					);
				}}
			/>
		</Fragment>
	);
};

export default SCThingsToDo;
